import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AppContext = createContext(null);

const STORAGE_KEY = "ep_app_context";

const currentAcademicYear = () => {
  const d = new Date();
  const y = d.getFullYear();
  // Sept onwards: current-next; else previous-current
  if (d.getMonth() >= 8) return `${y}/${y + 1}`;
  return `${y - 1}/${y}`;
};

export function AppProvider({ children }) {
  const [meta, setMeta] = useState(null);
  const [ctx, setCtx] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
      return {
        stage: saved.stage || "المرحلة الابتدائية",
        year: saved.year || currentAcademicYear(),
        semester: saved.semester || 1,
      };
    } catch {
      return { stage: "المرحلة الابتدائية", year: currentAcademicYear(), semester: 1 };
    }
  });

  useEffect(() => {
    api.get("/meta").then(({ data }) => setMeta(data)).catch(() => {});
  }, []);

  const setContext = (patch) => {
    setCtx((prev) => {
      const next = { ...prev, ...patch };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  };

  return (
    <AppContext.Provider value={{ ctx, setContext, meta }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  return useContext(AppContext);
}
